import path from 'path-browserify';

import { useTenantStore } from '@stores/tenant-store';
import { getBaseUrl } from '@api/base-url';

type DomainType = string | null;

const getDomain = () => useTenantStore().domain;

const base = ({
  domain,
  tenantUserId,
}: {
  domain: DomainType;
  tenantUserId?: number | null;
}): string => path.join(
  getBaseUrl({ version: 1 }),
  `tenants/${domain}/users/`,
  tenantUserId !== null ? `${tenantUserId}/` : '',
);

const urls = Object.freeze({
  currentTenantUser: ({ domain = getDomain() }): string => path.join(
    base({ domain, tenantUserId: null }),
    'current/',
  ),
  currentTenantUserDelete: ({ domain = getDomain() }): string => path.join(
    base({ domain, tenantUserId: null }),
    'current/delete/',
  ),
  tenantUserSkillTrees: ({
    domain = getDomain(),
    tenantUserId,
  }: {
    domain?: string;
    tenantUserId: number;
  }): string => path.join(
    base({ domain, tenantUserId }),
    'skill-trees/',
  ),
  tenantUserBacklogSkillTrees: ({
    domain = getDomain(),
    tenantUserId,
  }: {
    domain: string;
    tenantUserId: number;
  }): string => path.join(
    base({ domain, tenantUserId }),
    'backlog/skill-trees/',
  ),
  tenantUsers: ({
    domain = getDomain(),
    tenantUserId = null,
  }: {
    domain: string;
    tenantUserId: number | null;
  }): string => path.join(
    base({ domain, tenantUserId }),
    '',
  ),
  tenantUserSkills: ({
    domain = getDomain(),
    tenantUserId,
    tenantUserSkillId = null,
  }: {
    domain: string;
    tenantUserId: number;
    tenantUserSkillId: number | null;
  }): string => path.join(
    base({ domain, tenantUserId }),
    'skills/',
    tenantUserSkillId !== null ? `${tenantUserSkillId}/` : '',
  ),
  tenantUserSkillMatches: ({
    domain = getDomain(),
    tenantUserId,
  }): string => path.join(
    base({ domain, tenantUserId }),
    'skills/matches/',
  ),
  tenantUserTeamTenantUsers: ({
    domain = getDomain(),
    tenantUserId,
  }: {
    domain?: string;
    tenantUserId: number;
  }): string => path.join(
    base({ domain, tenantUserId }),
    'team-users/',
  ),
});

export default urls;
